import "./ClientFinancialAdministrationLead.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInCarignan from "./sections/PatioDoorRepairServicesInCarignan";
import WhyNevadaChoosesUs from "./sections/WhyNevadaChoosesUs";
import ServiceDetailsSealantRepair from "./sections/ServiceDetailsSealantRepair";
import Advantages from "./sections/Advantages";
import GolfCourse from "./sections/GolfCourse";
import Footer from "@/reusable_sections/Footer";
export default function ClientFinancialAdministrationLeadPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInCarignan />
      <WhyNevadaChoosesUs />
      <ServiceDetailsSealantRepair />
      <Advantages />
      <GolfCourse />
      <Footer />
    </div>;
}